<template>
    <div>
        <SignInPC v-if="isPC"/>
        <SignInH5 v-else/>
    </div>
</template>
<script>

    import SignInH5 from '../components/SignInH5';
    import SignInPC from '../components/SignInPC';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInPC,
            SignInH5
        },
        mounted() {
            enableAppShare({
                title: '前端中价课',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210415/1618467842481.png'
            });
        },
    };
</script>
